import React from 'react';
import { ClockIcon, UsersIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/solid';

const MobileChildSessionItem = ({
  childSession,
  crews,
  canModify,
  handleEdit,
  handleDelete,
  handleReschedule,
  handleViewDetails,
  formatSessionTiming,
}) => {
  return (
    <div className="space-y-2 border-b border-gray-200 p-4 pl-8 last:border-b-0">
      {/* Child Title and Status Row */}
      <div className="flex items-center justify-between">
        <button
          className="truncate text-left text-sm font-medium text-gray-800 transition-colors hover:text-blue-600"
          onClick={() => handleViewDetails(childSession)}
          title="View session details"
        >
          {childSession.title}
        </button>
        <span
          className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
            childSession.session_type === 'scheduled'
              ? 'bg-green-100 text-green-800'
              : 'bg-yellow-100 text-yellow-800'
          }`}
        >
          {childSession.session_type === 'scheduled' ? 'Scheduled' : 'Unscheduled'}
        </span>
      </div>

      {/* Child Time Row */}
      <div className="flex items-center text-xs text-gray-600">
        <ClockIcon className="mr-1 h-3 w-3" />
        <span>{formatSessionTiming(childSession)}</span>
      </div>

      {/* Child Crews Row */}
      <div className="text-xs text-gray-600">
        <div className="mb-1 flex items-center">
          <UsersIcon className="mr-1 h-3 w-3" />
          <span className="font-medium">Crews:</span>
        </div>
        <div className="ml-4">
          {!childSession.crew_assignments || childSession.crew_assignments.length === 0 ? (
            <span className="text-gray-500">Open Session</span>
          ) : (
            childSession.crew_assignments.map((assignment, index) => {
              const crew = crews.find((crew) => crew.id === assignment.crew_id);
              return (
                <div key={index} className="text-gray-700">
                  {crew?.name || 'Unknown Crew'}
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Child Actions Row */}
      {canModify && (
        <div className="flex gap-2 pt-1">
          {childSession.session_type === 'scheduled' && (
            <button
              onClick={() => handleReschedule(childSession)}
              className="flex items-center rounded border bg-yellow-100 px-2 py-1 text-xs text-yellow-700 hover:bg-yellow-200"
              title="Reschedule to unscheduled"
            >
              <ClockIcon className="mr-1 h-3 w-3" />
              Reschedule
            </button>
          )}
          <button
            onClick={() => handleEdit(childSession)}
            className="flex items-center rounded border bg-white px-2 py-1 text-xs text-gray-600 hover:bg-gray-50"
          >
            <PencilIcon className="mr-1 h-3 w-3" />
            Edit Time
          </button>
          <button
            onClick={() => handleDelete(childSession)}
            className="flex items-center rounded border bg-red-100 px-2 py-1 text-xs text-red-700 hover:bg-red-200"
            title="Delete session"
          >
            <TrashIcon className="mr-1 h-3 w-3" />
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileChildSessionItem;
